import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["children", "collapsible", "content", "defaultExpanded", "eventKey", "expanded", "onSelect", "title"];

/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors } from '@flowio/react-theme';
import { isElementOfType } from '@flowio/react-helpers';
import React from 'react';
import PanelContent from './PanelContent';
import PanelHeader from './PanelHeader';
var defaultProps = {
  collapsible: false,
  defaultExpanded: false
};
var rootStyles = /*#__PURE__*/css({
  maxWidth: '100%',
  border: "1px solid ".concat(colors.GRAY_500),
  borderRadius: '4px',
  backgroundColor: colors.WHITE,
  overflow: 'hidden'
}, process.env.NODE_ENV === "production" ? "" : ";label:rootStyles;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

var Panel = /*#__PURE__*/function (_React$Component) {
  _inherits(Panel, _React$Component);

  var _super = _createSuper(Panel);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickHeader", function (event) {
      var _this$props = _this.props,
          collapsible = _this$props.collapsible,
          eventKey = _this$props.eventKey,
          onSelect = _this$props.onSelect;
      var _this$state = _this.state,
          controlled = _this$state.controlled,
          expanded = _this$state.expanded;

      if (collapsible) {
        if (!controlled) {
          _this.setState({
            expanded: !expanded
          });
        }
      }

      if (typeof onSelect === 'function') {
        onSelect(event, eventKey);
      }
    });

    _this.state = _this.getInitialState();
    return _this;
  }

  _createClass(Panel, [{
    key: "getInitialState",
    value: function getInitialState() {
      var _this$props2 = this.props,
          expanded = _this$props2.expanded,
          defaultExpanded = _this$props2.defaultExpanded;
      return {
        expanded: expanded != null ? expanded : defaultExpanded,
        controlled: expanded != null
      };
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var prevExpanded = this.props.expanded;
      var nextExpanded = nextProps.expanded;

      if (nextExpanded != null && prevExpanded !== nextExpanded) {
        this.setState({
          expanded: nextExpanded,
          controlled: true
        });
      }
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this2 = this;

      var _this$props3 = this.props,
          children = _this$props3.children,
          collapsible = _this$props3.collapsible;
      var expanded = this.state.expanded;
      return React.Children.map(children, function (child) {
        if (! /*#__PURE__*/React.isValidElement(child)) {
          return child;
        }

        if (isElementOfType(child, PanelHeader)) {
          return jsx(child.type, _objectSpread(_objectSpread({
            key: child.key
          }, child.props), {}, {
            collapsible: collapsible,
            expanded: expanded,
            onClick: _this2.handleClickHeader
          }));
        }

        if (isElementOfType(child, PanelContent)) {
          return jsx(child.type, _objectSpread(_objectSpread({
            key: child.key
          }, child.props), {}, {
            collapsible: collapsible,
            expanded: expanded
          }));
        }

        return child;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          children = _this$props4.children,
          collapsible = _this$props4.collapsible,
          content = _this$props4.content,
          defaultExpanded = _this$props4.defaultExpanded,
          eventKey = _this$props4.eventKey,
          expandedProp = _this$props4.expanded,
          onSelect = _this$props4.onSelect,
          title = _this$props4.title,
          unhandledProps = _objectWithoutProperties(_this$props4, _excluded);

      var expanded = this.state.expanded;

      if (children != null) {
        return jsx("div", _extends({}, unhandledProps, {
          css: rootStyles
        }), this.renderChildren());
      }

      return jsx("div", _extends({}, unhandledProps, {
        css: rootStyles
      }), jsx(PanelHeader, {
        collapsible: collapsible,
        expanded: expanded,
        onClick: this.handleClickHeader,
        title: title
      }), jsx(PanelContent, {
        collapsible: collapsible,
        expanded: expanded,
        content: content
      }));
    }
  }]);

  return Panel;
}(React.Component);

_defineProperty(Panel, "defaultProps", defaultProps);

_defineProperty(Panel, "displayName", 'Panel');

export default Panel;